import Reveal from "@Components/Reveal/Reveal";
// The navbar's gradient pill IS the site's primary CTA — same class, not a copy
// of its rules, so the two cannot drift. It also carries the `color: #fff
// !important` guard the global `a:hover` rule needs.
import navStyles from "@Components/Navbar/Navbar.module.scss";
import APPLY_URL from "../../constants";
import styles from "./Hero.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";
import useTranslationHook from "hooks/useTranslationHook";

/**
 * Ambassador hero — headline, one line of copy, one CTA.
 *
 * Deliberately three things and nothing else. The reel rail below it is the
 * page's evidence; the hero's only job is to say what the programme is and offer
 * the way in. Anything more here competes with the rail for the same attention.
 *
 * Structurally this is NOT the other v2 heroes: no photo, no stat row, no
 * avatar cluster. Those pages sell a service to students; this one recruits
 * creators, and the reels are the argument.
 *
 * ── Copy is the OLD page's, not v2's own ───────────────────────────────────
 * These are the `ambassador.hero.*` keys the page this replaces used, restored
 * on request. The `ambassador.v2.hero.*` keys written for this rebuild ("Your
 * passport to free stays and a bigger audience." / "Apply to join") are now
 * unreferenced — left in translations.json rather than deleted across all eight
 * locales, so switching back is a one-line change.
 *
 * ⚠️  THE SUBHEADING IS THE DESKTOP VARIANT, ON BOTH DEVICES. The old page split
 * this: `ambassador.desktop.hero.subheading` on desktop (107 chars) and the
 * shorter `ambassador.hero.subheading` on mobile (92), because it had two
 * separate hero components. AmbassadorV2 is ONE component tree used by both
 * `routes/index.ts` and `routes/desktop/index.ts`, so there is no per-device key
 * to pick here and one string has to serve both. The fuller desktop line is the
 * one chosen; the mobile key still exists if the 15-character difference turns
 * out to matter at a phone width.
 */
const Hero = () => {
  const { t } = useTranslationHook();

  return (
    <section className={styles.hero}>
      <Reveal as="h1" className={styles.title}>
        {t("ambassador.hero.heading.line1")}
        <br />
        {t("ambassador.hero.heading.line2")}
      </Reveal>

      <Reveal className={styles.lede} delay={120}>
        <p className={styles.subtitle}>{t("ambassador.desktop.hero.subheading")}</p>

        {/*
        Opens the programme's Typeform in a new tab, which is what every CTA on
        the page this replaces did. `rel="noreferrer"` rather than just
        `noopener`: the form's own source parameter already carries the
        attribution, so the referrer adds nothing and leaks the path.

        ⚠️  The button is the SITE's primary CTA, not the reference's. The layout
        this page borrows — headline, one line, one button, a reel rail — came
        from elsewhere; its black pill did not. Every other v2 hero uses
        `navStyles.tryButton`, and so does this one.
      */}
        <a
          className={navStyles.tryButton}
          href={APPLY_URL}
          target="_blank"
          rel="noreferrer"
          data-testid="ambassador-v2-apply"
        >
          {t("ambassador.hero.cta")}
        </a>
      </Reveal>
    </section>
  );
};

export default wrapperHOC(Hero, {
  componentName: "Hero-AmbassadorV2",
  showForChina: true,
});
